import { useSetAtom } from 'jotai';
import { useEffect } from 'react';

import { documentTitlePrefixAtom } from '@frontend/atoms';

import { useBadgeCount } from './useBadgeCount';
import { useNotificationFeatures } from './useNotificationFeatures';
import { useUnreadCount } from './useUnreadCount';

export function useNotificationTitle() {
  const { badgeEnabled, groupingEnabled } = useNotificationFeatures();

  const { data: badgeCount } = useBadgeCount({ enabled: badgeEnabled, grouped: groupingEnabled });
  const { data: unreadCount } = useUnreadCount({
    enabled: !badgeEnabled,
    grouped: groupingEnabled,
  });
  const setPrefix = useSetAtom(documentTitlePrefixAtom);

  useEffect(() => {
    const count = (badgeEnabled ? badgeCount : unreadCount) ?? 0;
    setPrefix(count > 0 ? `(${count}) ` : '');

    return () => setPrefix('');
  }, [badgeEnabled, badgeCount, unreadCount, setPrefix]);
}
